import React, { useCallback, useEffect, useRef, useState } from 'react'

import _ from 'lodash'
import { Button } from 'primereact/button'
import { DataView } from 'primereact/dataview'
import { InputText } from 'primereact/inputtext'
import cls from './search.module.scss';
import {Dialog} from "primereact/dialog";
import {
    checkLen,
    extract,
    matchRecordField,
    formatValue,
    markDisplay,
    renderRecord,
    renderRecordField,
    renderValue, FieldTypes, wrapArray, recordFieldByLocation,
    parseHtml as parseHtmlRaw, formatValueWithCustom
} from "../utils";

import {useFormikContext} from "formik";
import {convertMDToHTML} from "../../helpers/convertMDToHTML";
import {OverlayPanel} from "primereact/overlaypanel";
import {getSearchFields} from "../AirtableFields/RecordLinks/search.common";
import {ProgressSpinner} from "primereact/progressspinner";
import {useStore} from "../../@redux";
import {useDebouncedEffect} from "../../hooks/useDebouncedEffect";

type RecordSearchProps = {
    visible: boolean
    isInQuery: boolean
    records: any[]
    onQuery: (query:string, after?: (records: any[]) => void ) => void
    render_as?: string
    debounceInterval?: number
    displaySelectedCount?: number
    onHide?: () => void
    openEvent?: any
    field: any
    details: any
    initSearchTerm?: string
    initSelected?: any | any[]
    hideInitSelected?: boolean
    multiple?: boolean
    showSelected?: boolean
    showSearch?: boolean
    showImage?: boolean
    disableSelect?: boolean
    allowEmptySelection?: boolean
    allowRemoveTopSelected?: boolean
    allowDblClickDone?: boolean
    allowClickDone?: boolean
    onSelect?: (record: any) => void
    onDeSelect?: (record: any) => void
    onDone?: (records: any[]) => void
    allowCreateNew?: boolean
}
const SORT_ORDERS = [
    { id: 'asc', name: 'Ascending' },
    { id: 'desc', name: 'Descending' },
]
const ignoreThis = (action) => (record) => {

}

const RecordSearch = (props: RecordSearchProps) => {
    const {
        visible = false,
        render_as = 'dialog',
        openEvent = null,
        isInQuery = false,
        onHide = () => {},
        details = {} as any,
        records = [],
        initSelected = [],
        hideInitSelected = false,
        initSearchTerm = '',
        debounceInterval = 2500,
        displaySelectedCount = 5,
        multiple = true,
        allowRemoveTopSelected = true,
        allowEmptySelection = false,
        showSelected = true,
        showSearch = true,
        showImage = true,
        disableSelect = false,
        allowCreateNew = false,
        allowClickDone = false,
        allowDblClickDone = true,
        onQuery = (q) => {},
        onSelect = ignoreThis('select'),
        onDeSelect = ignoreThis('deselect'),
        onDone = ignoreThis('done'),
    } = props

    const store = useStore()
    const overlayRef = useRef(null)
    const [lastSearch,setLastSearch] = useState<string>(null)
    const [searchText, setSearchText] = useState<string>(initSearchTerm)
    const [pageFirst, setPageFirst] = useState<number>(0)
    const [displayAllSelected, setDisplayAllSelected] = useState(false)
    const [selectedRecords, setSelectedRecords] = useState<any[]>( [] )
    const {
        values: formValues,
    } = useFormikContext();
    console.log('Starting Record Search')

    useEffect(() => {
        if(visible){
            console.log(new Date().toISOString(),'**doQuery**','visible useEffect',{visible,isInQuery, searchText, lastSearch})
            doQuery(searchText)
        }
    }, [visible])

    useDebouncedEffect( () => {
        console.log(new Date().toISOString(),'**doDebouncedQuery**',{isInQuery, searchText, lastSearch})
        if(isInQuery){

        }else if(searchText !== lastSearch && lastSearch !== null) {
            onQuery(searchText)
            setLastSearch(searchText)
        }
    }, [searchText], debounceInterval)

    useEffect( () => {
        if(overlayRef.current && openEvent){
            console.log('overlay ready', openEvent)
            overlayRef.current.show(openEvent)
        }
    }, [overlayRef.current,openEvent])
    const initSelectedList = initSelected ? (wrapArray(initSelected)).map( i => i.tableRecordId ).join(",") : ''
    useEffect( () => {

        console.log('Setting Initial Selected', initSelected)
        setSelectedRecords( wrapArray(initSelected) )
    }, [initSelectedList])



    const doQuery = (query) => {
        console.log(new Date().toISOString(),'**doQuery**',{query, isInQuery, searchText, lastSearch})
        // if(isInQuery){
        //
        // }else {
        //     onQuery(query)
        //     setLastSearch(query)
        // }
    }
    //useCallback( ,[onQuery,lastSearch,isInQuery,setLastSearch,searchText])

    // const performQuery = _.debounce(doQuery, debounceInterval)
    useEffect( () => {
        if(!isInQuery && lastSearch !== searchText){
            console.log(new Date().toISOString(),'**performQuery**','isInQuery useEffect',{searchText, lastSearch})
            // performQuery(searchTxt)
            // performQuery.flush()
            onQuery(searchText)
            setLastSearch(searchText)
        }
    }, [isInQuery])
    useEffect( () => {
        if(!isInQuery && records.length === 1 && searchText && details.search?.instant_single_select ){
            //make sure not already selected
            const instant = records[0]
            const isSelected = selectedRecords.find( sr => sr.tableRecordId === instant.tableRecordId )
            if(!isSelected)toggleSelected(instant)
            setSearchText("")
        }
    }, [records.length])

    const updateSearchText = (search) => {
        setSearchText(search)
        console.log(new Date().toISOString(),'**performQuery**','updateSearchText',{search,searchText,lastSearch})
        //perform query after debounce
        // performQuery( search )
    }




    const onCreateNew = async () => {
        const record = null//create new
        if (record) {
            toggleSelected(record)
        }

    }


    const parseHtml = (html, text) => {
        let value = text
        try {
            if(html)value = parseHtmlRaw(html)
        } catch (ignore) { }
        return value
    }

    const renderHeader = () => {
        let cols = [0, 9, 0]

        return (
            <div style={{}}>
                <div className="p-grid p-nogutter">
                    <div className={`p-col-${cols[0]}`}>
            <span className="x-buttonset">
              {allowCreateNew  && (
                  <Button
                      label={'CREATE NEW'}
                      onClick={onCreateNew}
                      className="p-button-primary btnLayout"
                      style={{marginTop: "3px"}}
                      icon={'pi pi-plus'}
                  />

              )}
            </span>
                    </div>
                    {showSearch && (
                        <div className={`p-col-${cols[1]}`}>
                            <div className="p-inputgroup">
                                <Button icon="pi pi-search" className="p-button-primary" />
                                <InputText
                                    value={searchText}
                                    style={{ width: '80%' }}
                                    className=""
                                    placeholder={'Search...'}
                                    autoFocus={true}
                                    onChange={(e) => updateSearchText(e.target.value)}
                                />
                                <Button
                                    disabled={!searchText}
                                    onClick={() => updateSearchText('')}
                                    icon="pi pi-times"
                                    className="p-button-secondary"
                                />
                            </div>
                        </div>
                    )}

                </div>
                {showSelected && (
                    <div className="p-grid p-nogutter" style={{ paddingTop: '5px' }}>
                        <div className={`p-col-12`}>{renderSelectedTop()}</div>
                    </div>
                )}
            </div>
        )
    }
    const renderSelectedTop = () => {
        const showNum = displayAllSelected ? selectedRecords.length : displaySelectedCount
        const primaryField = recordFieldByLocation('primary', details )
        const primaryFieldName = primaryField?.name
        const showSelectedRecs =
            selectedRecords.length <= showNum
                ? selectedRecords
                : [
                    ...selectedRecords.slice(0, showNum),
                    { tableRecordId: false, expand: true, name: `+${selectedRecords.length - showNum} more` },
                ]
        const getName = (rec) => {
            let name =
                (rec.tableRecordId ? `${formatValue('search', rec[primaryFieldName], primaryField) || ''}` : rec.name) || ''
            return name.length > 50 ? name.substring(0, 50) + '...' : name
        }

        if (selectedRecords.length) {
            if (allowRemoveTopSelected) {
                return (
                    <>
                        ({selectedRecords.length}) Selected:{' '}
                        {showSelectedRecs.map((record) =>
                             (
                                <div
                                    key={record.tableRecordId}

                                    style={{
                                        display:"inline-flex",
                                        alignItems:"center",
                                        backgroundColor: record.tableRecordId ? 'rgb(233, 238, 249)' : 'hsl(0,0%,95%)',
                                        borderRadius: '3px',
                                        padding: '3px 8px',
                                        marginTop: '2px',
                                        marginLeft: '2px',
                                        height: '28px',
                                    }}
                                >
                                    <p style={{display: 'flex', minWidth:0}}>
                                        {getName(record) || '-'}
                                    </p>
                                    {record.tableRecordId && (multiple || allowEmptySelection) && (
                                        <i className="pi pi-times"
                                           style={{ fontSize: '0.75em', cursor: 'pointer', marginLeft: '3px' }}
                                           onClick={() => toggleSelected(record)}/>

                                    )}
                                    {record.expand && (
                                        <i className="pi pi-angle-double-right"
                                           style={{ fontSize: '1em', cursor: 'pointer', marginLeft: '3px' }}
                                           onClick={() => setDisplayAllSelected(true)}/>
                                    )}
                                </div>
                            ),
                        )}
                    </>
                )
            } else {
                return (
                    <p>
                        {multiple ? `(${selectedRecords.length}) ` : ''}Selected:{' '}
                        {showSelectedRecs
                            .filter((sr) => !sr.isDeleted)
                            .map((sr) => getName(sr))
                            .join(' | ')}
                    </p>
                )
            }
        } else if(multiple){
            return <span>No Records Selected</span>
        }else{
            return <></>
        }
    }



    const renderField = (env, initFieldInfo, record, location, opts = {}) => {

        const fieldInfo = {...(initFieldInfo || {})}
        // const selectedRec = location === 'primary' && isSelected(record)
        // const showSelectedRec = selectedRec ? (
        //         <i className="pi pi-check font-weight-500"
        //            style={{  color: '#2196f3', paddingRight: '5px' }}
        //            />
        // ) : (
        //     <></>
        // )

        let value = formatValueWithCustom( env, record[fieldInfo.name], fieldInfo, details, record )

        if(fieldInfo.render_as === 'markdown'){
            value = convertMDToHTML( value )
            fieldInfo.render_as = 'html'
        }
        let marked = ''
        if (searchText && getSearchFields(details).find( sf => sf.id === fieldInfo.id || sf.name === true )) {
            const useType = fieldInfo.options?.lookupFieldType || fieldInfo.type
            switch (useType) {
                case FieldTypes.FT_ATTACHMENTS:
                case FieldTypes.FT_BUTTON:
                case FieldTypes.FT_CHECKBOX:
                case FieldTypes.FT_BARCODE:
                    break //skip these
                default:

                    marked = markDisplay(value, searchText)
                    break
            }
        }
        value = renderValue( value, fieldInfo )
        value = parseHtml(marked, value)
        console.log('Rendering field', fieldInfo, value )
        return renderRecordField( 'search', fieldInfo, record, location, {showCheck: multiple, value, selected: isSelected(record), store, details})

    }
    const toggleSelected = (record) => {
        if (disableSelect) return
        let list = []
        let add = true
        selectedRecords.forEach((sr) => {
            if (sr.tableRecordId === record.tableRecordId) {
                if (multiple || allowEmptySelection) {
                    add = false
                    onDeSelect(record)
                } else if (!multiple && allowDblClickDone) {
                    setSearchText("")
                    onDone( record )
                }
            } else {
                list.push(sr)
            }
        })

        if (add) {
            if (!multiple && list.length) {
                list.map(onDeSelect)
                list = []
            }
            onSelect(record)
            list.push(record)
            if(allowClickDone && !multiple){
                setSearchText("")
                onDone( record )
            }

        }
        setSelectedRecords(list)
    }
    const isSelected = (record) => {
        return selectedRecords.find((sr) => sr.tableRecordId === record.tableRecordId)
    }

    const renderListItem = (record, layout) => {
        console.log("Render List", record, layout)
        return renderRecord( 'search', record, {multiple, ...details}, {layout,selected: isSelected(record), render: renderField, onClick: toggleSelected, store, details})

    }

    const renderGridItem = (record, layout) => {
        return renderListItem(record, layout)
    }
    const itemTemplate = (record, layout) => {
        //console.log('Rendering Record', layout, record)
        if (!record) {
            return
        }

        if (layout === 'list') return renderListItem(record, layout)
        else if (layout === 'grid') return renderGridItem(record, layout)
    }

   const emptyMsg = () => {
       const inner = <><ProgressSpinner/>{details.searchingMessage || 'Searching...'}</>

       return !isInQuery ? details.emptyMessage || 'No Items Found' : (
           <div style={{display: 'flex', justifyContent: 'center'} }><div style={{fontWeight: '700'}}>
               {inner}
           </div></div>
       )
   }
    const useRecords = () => {
        if(isInQuery)return []
        console.log('Use Records', initSelected)
        if(hideInitSelected && wrapArray(initSelected).length){
            const initIds = initSelected.map( is => _.isString(is) ? is : _.get(is, 'tableRecordId'))
            return records.filter( rec => !initIds.includes(rec.tableRecordId) )
        }
        return records
    }
    const showHeader = ['overlay','inline'].includes(render_as)
    const view = (
        <div className={cls.searchContainer}>
            {showHeader && renderHeader()}
            <DataView
                value={useRecords()}
                itemTemplate={itemTemplate}
                first={pageFirst}
                emptyMessage={emptyMsg()}
                onPage={(e) => setPageFirst(e.first)}
                {...extract( {layout: 'list', paginator: true, rows: 20,
                    paginatorPosition: undefined, alwaysShowPaginator: undefined,paginatorClassName: undefined, paginatorTemplate: undefined,
                    pageLinkSize: undefined, rowsPerPageOptions: undefined, currentPageReportTemplate: undefined, sortField: undefined, sortOrder: undefined,
                style: { paddingTop: '5px', paddingRight: '5px', overflowY: 'clip' }, className: cls.pDataviewList, gutter: true }, details.search || {})}
            />
        </div>
    )
    if(visible) {
        if (render_as === 'dialog') {
            const dialogHeader = (
                <>
                    <div style={{minHeight: '60px'}}>
                        <div style={{fontWeight: 700, fontSize: '2.0rem', float: 'left'}}>{details.title || 'Select Record' + (multiple ? 's' : '')}</div>

                    </div>

                    {renderHeader()}
                </>
            )
            const dialogFooter = (
                <div className={'pt-2'}>
                    {(multiple || allowEmptySelection || selectedRecords.length > 0) && <Button label={details.done_label || 'DONE'}
                                                                                                onClick={() => {
                                                                                                    setSearchText("")
                                                                                                    onDone(selectedRecords)
                                                                                                }}/>}
                </div>
            )
            return <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '85vw', height: '85vh'}}
                           header={dialogHeader} footer={dialogFooter} visible={visible} resizable={false} draggable={false}
                           onHide={onHide} closable={false}>
                {view}
            </Dialog>
        }else if(render_as === 'overlay'){
            return <OverlayPanel ref={overlayRef} breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw'}} showCloseIcon dismissable>
                {view}
            </OverlayPanel>
        }
        return view
    }
    return <></>
}

export default RecordSearch
